var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-breadcrumb',{staticClass:"breadcrumb"},[_c('a-breadcrumb-item',[_c('a-icon',{attrs:{"type":"home"}})],1),_vm._v(" "),_vm._l((_vm.$route.meta.breadcrumb),function(item,index){return _c('a-breadcrumb-item',{key:index},[_c('span',{on:{"click":function($event){return _vm.jump(item)}}},[_vm._v(_vm._s(item.name))])])})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9cc5410","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/comm/components/center/Breadcrumb.vue
// module id = null
// module chunks = 